import { NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
	CategoryLinkPipe,
	CdnPathPipe,
	EntitiesPipe,
	HelperService,
	UcDatePipe,
} from '@uc/utilities';

@Component({
	selector: 'uc-advice-featured-card',
	templateUrl: './advice-featured-card.component.html',
	imports: [
		RouterModule,
		NgStyle,
		CdnPathPipe,
		CategoryLinkPipe,
		EntitiesPipe,
		UcDatePipe,
	],
})
export class AdviceFeaturedCardComponent implements OnInit {
	@Input() article!: any;
	urlParts!: string[];

	constructor(private _helper: HelperService) {}

	ngOnInit(): void {
		//to ensure forward slashes are not encoded by routerLink
		this.urlParts = this._helper.splitUrlIntoParts(this.article.url);
	}
}
